import { DataAccessService } from "../../core/api";

export async function deleteRepos(reposToDelete) {
    const client = new DataAccessService({
        baseURL: `${window.location.protocol}//${window.location.host}`
    });

    return await client.delete('/repos', reposToDelete, {});
}